interface FixedFooterProps {
  classes?: string
  children: React.ReactNode
}

const FixedFooter = ({ classes = '', children }: FixedFooterProps) => {
  return <footer className={`fixed-footer ${classes}`}>{children}</footer>
}

export default FixedFooter
